<div class="rounded-lg p-6 shadow-sm border bg-blue-50 border-blue-200">
  <div class="flex mb-4">
    <h2 class="text-lg font-semibold">
      {{ question.question }}<span *ngIf="question.is_required" class="text-red-500"> *</span>
    </h2>
  </div>
  <div class="space-y-4 px-10">
    <div *ngFor="let answer of question.answers" class="quiz-option flex flex-col">
      <div class="flex items-start">
        <input
          type="checkbox"
          [id]="'checkbox-' + answer.uuid"
          [value]="answer.uuid"
          disabled
          class="appearance-none h-5 w-5 border-2 border-blue-300 rounded checked:bg-blue-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 transition-all cursor-pointer"
        />
        <div class="ml-3 flex-1">
          <label
            [for]="'checkbox-' + answer.uuid"
            class="cursor-pointer select-none block leading-6 break-words"
          >
            {{ answer.answer }}
          </label>
        </div>
      </div>
    </div>
  </div>
</div>
